<template>
  <main class="px-4 pt-4">
    <div class="d-flex flex-row justify-content-between align-items-center mb-4">
      <h1>
        {{ $t('Tracking') }}
      </h1>
      <dx-button
        :text="$t('Add containers')"
        icon="ace-icon icon-plus"
        type="success"
        styling-mode="contained"
        class="custom-btn mr-2"
        @click="addContainers"
      />
    </div>

    <dx-data-grid
      ref="monitoringGrid"
      :data-source="dataSource"
      :remote-operations="remoteOperations"
      :allow-column-reordering="true"
      :show-borders="true"
      :column-min-width="65"
      :column-auto-width="true"
      :allow-column-resizing="true"
      column-resizing-mode="widget"
      :hover-state-enabled="true"
      date-serialization-format="yyyy-MM-dd"
      class="mb-5"
      :on-row-dbl-click="onRowDblClick"
      @toolbar-preparing="onToolbarPreparing"
    >
      <dx-column
        data-field="container"
        :caption="$t('Container')"
        :allow-editing="true"
      />
      <dx-column
        data-field="company_name"
        :caption="$t('Company')"
        :allow-editing="false"
      />

      <dx-column
        data-field="last_location_operation_type"
        :allow-editing="false"
        header-cell-template="localTemp"
        cell-template="lastLocationTemplate"
      />

      <template #localTemp>
        <img
          :src="require('@/icons/icon-place.svg')"
          width="30px"
        >
      </template>
      <template #lastLocationTemplate="{ data }">
        <img
          :src="require('@/icons/'+ iconsTypes[data.displayValue].url)"
          alt="logo"
          width="30px"
        >
      </template>

      <dx-column
        data-field="last_location"
        :caption="$t('Current operation')"
        :allow-editing="false"
      />

      <dx-column
        data-field="last_location_code"
        :caption="$t('Station code')"
        :allow-editing="false"
      />

      <dx-column
        data-field="last_status_date"
        :caption="$t('Date')"
        :allow-editing="false"
        data-type="date"
      />

      <dx-column
        data-field="last_transport"
        :caption="$t('Transport')"
        :allow-editing="false"
      />

      <dx-column
        data-field="transit_status"
        :caption="$t('Сustoms clearance status')"
        :allow-editing="false"
      />

      <!-- <dx-column
        data-field="modify_date"
        :caption="$t('Date')"
        data-type="date"
        :allow-editing="false"
      /> -->


      <!-- <dx-column
        data-field="freight_order"
        :caption="$t('Shipping order')"
        :allow-search="true"
        :allow-editing="false"
      /> -->

      <!-- <dx-column
        data-field="freight_order_status"
        :caption="$t('Freight order status')"
        :lookup="statusLookup"
        :allow-editing="false"
      /> -->

      <!-- <dx-column
        data-field="last_location_date"
        :caption="$t('Arrival date')"
        :allow-editing="false"
        data-type="date"
      /> -->


      <!-- <dx-column
        data-field="last_status"
        :caption="$t('Status')"
        :allow-editing="false"
      /> -->

      <!-- <dx-column
        :caption="$t('sea')"
        data-field="sea"
        header-cell-template="locationTemplate"
        :visible="false"
      >
        <dx-column
          data-field="sea_loading_port"
          :caption="$t('Loading port')"
          :allow-editing="false"
          data-type="text"
          :visible="false"
        />
        <dx-column
          data-field="sea_status"
          :caption="$t('sea status')"
          :allow-editing="false"
          data-type="text"
          :visible="false"
        />
        <dx-column
          data-field="sea_status_date"
          :caption="$t('status date')"
          :allow-editing="false"
          data-type="date"
          :visible="false"
        />
        <dx-column
          data-field="sea_vessel_name"
          :caption="$t('vessel name')"
          :allow-editing="false"
          data-type="text"
          :visible="false"
        />
        <dx-column
          data-field="sea_arrival_document_number"
          :caption="$t('document number')"
          :allow-editing="false"
          data-type="text"
          :visible="false"
        />
        <dx-column
          data-field="sea_unloading_port"
          :caption="$t('Unloading port')"
          :allow-editing="false"
          data-type="text"
          :visible="false"
        />
      </dx-column> -->
      <!-- <dx-column
        :caption="$t('port')"
        header-cell-template="locationTemplate"
        data-field="port"
        :visible="false"
      >
        <dx-column
          data-field="sea_arrival_date"
          :caption="$t('Arrival date')"
          :allow-editing="false"
          data-type="date"
        />
        <dx-column
          data-field="port_forwarding_status"
          :caption="$t('status')"
          :allow-editing="false"
          data-type="date"
          width="200px"
        />
      </dx-column> -->
      <!-- <dx-column
        :caption="$t('Customs')"
        data-field="border"
      > -->
      <!--
        <dx-column
          data-field="transit_status_date"
          :caption="$t('Date')"
          :allow-editing="false"
          data-type="date"
        /> -->

      <!-- <dx-column
          data-field="td_number"
          :caption="$t('td number')"
          :allow-editing="false"
          data-type="text"
          :visible="false"
        />
        <dx-column
          data-field="pi_number"
          :caption="$t('pi number')"
          :allow-editing="false"
          data-type="text"
          :visible="false"
        /> -->
      <!-- </dx-column> -->

      <!-- <dx-column
        :caption="$t('railway')"
        header-cell-template="locationTemplate"
        data-field="railway"
        :visible="false"
      >
        <dx-column
          data-field="railway_document_number"
          :caption="$t('document number')"
          :allow-editing="false"
          data-type="text"
          :visible="false"
        />
        <dx-column
          data-field="railway_transport_number"
          :caption="$t('transport number')"
          :allow-editing="false"
          data-type="text"
          :visible="false"
        />
        <dx-column
          data-field="railway_location"
          :caption="$t('Location')"
          :allow-editing="false"
          data-type="text"
        />
        <dx-column
          data-field="railway_location_date"
          :caption="$t('location date')"
          :allow-editing="false"
          data-type="date"
        />
        <dx-column
          data-field="railway_destination"
          :caption="$t('destination')"
          :allow-editing="false"
          data-type="text"
          :visible="false"
        />
        <dx-column
          data-field="railway_wagon_number"
          :caption="$t('wagon number')"
          :allow-editing="false"
          data-type="text"
          :visible="false"
        />
      </dx-column> -->

      <!-- <dx-column
        :caption="$t('warehouse')"
        header-cell-template="locationTemplate"
        data-field="warehouse"
        :visible="false"
      >
        <dx-column
          data-field="destination_arrival_registered"
          :caption="$t('arrival registered')"
          :allow-editing="false"
          data-type="date"
          width="120px"
        />
        <dx-column
          data-field="destination_transit_done"
          :caption="$t('transit done')"
          :allow-editing="false"
          data-type="date"
        />
      </dx-column> -->

      <template #locationTemplate="{ data }">
        <img
          :src="require('@/icons/'+ iconsTypes[data.column.dataField].url)"
          alt="logo"
          width="25px"
        >
      </template>

      <dx-group-panel :visible="true" />
      <dx-header-filter :visible="true" />
      <dx-search-panel
        :visible="true"
        :highlight-case-sensitive="false"
      />
      <dx-export
        :enabled="true"
        :allow-export-selected-data="true"
        file-name="monitoring"
      />
      <dx-column-chooser :enabled="true" />
      <dx-state-storing
        :enabled="true"
        type="localStorage"
        :storage-key="`u${user.id}-monitoring-grid-storage`"
      />
      <dx-paging :page-size="10" />
      <dx-pager
        :visible="true"
        :show-info="false"
        :show-navigation-buttons="true"
        :show-page-size-selector="true"
        :allowed-page-sizes="[10, 15, 20, 50]"
      />
      <dx-editing
        :allow-updating="user.is_manager && !isMobile"
        :use-icons="true"
        :allow-adding="false"
        :allow-deleting="user.is_manager && !isMobile"
        mode="cell"
      />
    </dx-data-grid>
  </main>
</template>

<script>
import {
  DxDataGrid,
  DxExport,
  DxColumn,
  DxColumnChooser,
  DxEditing,
  DxHeaderFilter,
  DxGroupPanel,
  DxSearchPanel,
  DxStateStoring,
  DxPaging,
  DxPager,
} from 'devextreme-vue/data-grid';

import { DxButton } from 'devextreme-vue';
import { mapState } from 'vuex';
import ruMessages from 'devextreme/localization/messages/ru.json';
import { locale as localize, loadMessages } from 'devextreme/localization';

import createCustomStore from '@/utils/create-custom-store';
import mixinDetictingMobile from '@/mixins/mixin-detecting-mobile';
import createStatusLookup from '@/utils/create-status-lookup';


export default {
  name: 'MonitoringGrid',
  components: {
    DxDataGrid,
    DxColumn,
    DxGroupPanel,
    DxSearchPanel,
    DxEditing,
    DxHeaderFilter,
    DxExport,
    DxColumnChooser,
    DxStateStoring,
    DxPaging,
    DxPager,
    DxButton,
  },
  mixins: [mixinDetictingMobile],
  data: vue => ({
    baseURL: process.env.VUE_APP_API_URL,
    remoteOperations: {
      sorting: true,
      filtering: true,
      paging: true,
    },
    dataSource: createCustomStore('container_tracking/api/container/'),
    statusLookup: createStatusLookup(vue),
    iconsTypes: {
      port: {
        url: 'icon-ship.svg',
      },
      border: {
        url: 'icon-customs.svg',
      },
      railway: {
        url: 'icon-train.svg',
      },
      car: {
        url: 'icon-car.svg',
      },
      warehouse: {
        url: 'icon-storage.svg',
      },
    },
  }),
  computed: {
    ...mapState(['user']),
  },
  created() {
    loadMessages(ruMessages);
    localize(this.$i18n.locale);
  },
  methods: {
    onToolbarPreparing(e) {
      e.toolbarOptions.items.unshift({
        location: 'after',
        widget: 'dxButton',
        hint: this.$t('refresh'),
        options: {
          icon: 'ace-icon icon-refresh',
          hint: this.$t('refresh'),
          onClick: this.refreshDataGrid.bind(this),
        },
      }, {
        location: 'after',
        widget: 'dxButton',
        options: {
          icon: 'ace-icon icon-close',
          hint: this.$t('clear_filters'),
          onClick: this.clearFilter.bind(this),
        },
      });
    },
    refreshDataGrid() {
      this.$refs.monitoringGrid.instance.refresh();
    },
    clearFilter() {
      this.$refs.monitoringGrid.instance.clearFilter();
    },
    onRowDblClick(e) {
      this.$router.push(`/tracking/container/${e.data.id}`);
    },
    addContainers() {
      this.$router.push('/tracking/add-containers');
    },

  },
};
</script>
